import { render } from "./classes.vue?vue&type=template&id=1fc9d5f0"
import script from "./classes.vue?vue&type=script&lang=js"
export * from "./classes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__